<template>
    <div :class="['tag', type, { 'icon-filled': iconFilled, 'no-overflow': noOverflow }]">
        <div class="md-icon" v-if="icon">{{ icon }}</div>
        <div class="text"><slot/></div>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'tag',
        props: {
            icon: String,
            type: String,
            iconFilled: Boolean,
            noOverflow: Boolean,
        }
    });

</script>

<style scoped lang="scss">

    .tag {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        min-width: 0;
        max-width: 100%;
        width: fit-content;
        gap: 6px;
        padding: 4px 8px;
        border-radius: 8px;
        color: var(--grey-900);
        background-color: var(--background-grey-2);
        cursor: default;

        .md-icon {
            font-size: 16px;
            color: inherit;
            flex-shrink: 0;

            &:empty {
                display: none;
            }
        }

        &.icon-filled .md-icon {
            font-variation-settings: 'FILL' 1;
        }

        .text {
            @extend %label-regular;
            color: inherit;
        }

        &.no-overflow .text {
            @extend %no-overflow;
        }

        &.primary {
            background-color: var(--primary-100);
            color: var(--primary-500);
        }

        &.success {
            background-color: var(--success-100);
            color: var(--success-600);
        }

        &.danger {
            background-color: var(--danger-100);
            color: var(--danger-600);
        }

        &.warning {
            background-color: var(--info-100);
            color: var(--info-500);
        }

        &.blue {
            background-color: var(--extra-backgrounds-blue-100);
            color: var(--extra-blue);
        }
    }

</style>